import React from 'react';
import { ShiftProviderUser } from 'models';
import { Colors } from 'library';
import { Avatar, Icon, Link, Row, Tooltip } from 'library/ui';
import { AccessTime } from '@mui/icons-material';

export default function ProviderDisplay({
    provider,
    clockedInTime,
}: {
    provider: ShiftProviderUser;
    clockedInTime?: string;
}) {
    return (
        <Row gap="sm" align="center">
            <Avatar
                imageUrl={provider.profile_picture?.image}
                initials={provider.first_name[0] + provider.last_name[0]}
                size={25}
                color={Colors.primary}
            />
            <Link to={`/provider/${provider.id}`} weight="semibold">
                {provider.first_name} {provider.last_name}
            </Link>
            {clockedInTime && (
                <Tooltip body={`Clocked in at ${clockedInTime}`}>
                    <Icon icon={AccessTime} size="sm" iconColor={Colors.secondary} bgColor={Colors.secondarySoft} />
                </Tooltip>
            )}
        </Row>
    );
}
